import React from 'react';
import cn from 'classnames';
import {Listbox, Transition} from '@headlessui/react';
import {IOption, OptionSelectedState} from '../UIOption';
import UIMultiSelectListboxOption from './UIMultiSelectListboxOption';

type Props = {
  options: IOption<OptionSelectedState>[]
  open: boolean
  className?: string
  onClick: (option: IOption<OptionSelectedState>) => void
};

/**
 * A default list of options for dropdown
 */
export default function UIMultiSelectOptionList({
  options, open, className, onClick,
}: Props) {
  return (
    <Transition show={open} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0"
      className={cn(className, 'absolute mt-1 w-full rounded-md bg-white shadow-lg z-50')}>
      <Listbox.Options
        static
        className="max-h-80 rounded-md py-1 leading-6 shadow-xs overflow-auto focus:outline-none border-gray border
         border-opacity-40"
      >
        {options.map((option, index) => <UIMultiSelectListboxOption
          key={option.value} option={option} onClick={onClick} first={index === 0}/>)}
      </Listbox.Options>
    </Transition>
  );
}
